import React from 'react';
import { Carousel } from '@jbhi-fi/lanyard-ui/components/Carousel';
import { InstallProductService } from '../../pdp/installProductService/InstallProductService';
import ProductService from '../../pdp/productService/ProductService';
import { LineItemProps, ServiceOffering } from '@jbhi-fi/apis/src/services/types';
import { styles } from './CartService.css';
import { Facets } from '../../pdp/installProductService/types';
import { INSTALL_ID_PREFIX } from '@jbhi-fi/components/src/Attach/ServicesInfoBlock/ServicesInfoBlock';

export type ServicesModuleConfig = {
  variant: 'cart' | 'minicart';
  lineId: string;
  productSku: string;
  productServiceLink?: string;
  gtmData?: any;
  installSuggestions?: Array<LineItemProps>;
  nonInstallSuggestions?: Array<LineItemProps>;
  nonInstallServiceData?: ServiceOffering;
  onAddService?: (offeringId?: string) => Promise<void>;
  trackingMessage?: string;
  preSelectedOfferingId?: string;
  facets?: Facets;
};

export const renderInstallModule = ({
  variant,
  lineId,
  productSku,
  productServiceLink,
  installSuggestions,
  preSelectedOfferingId,
  facets,
}: ServicesModuleConfig) => {
  if (!installSuggestions?.length) return null;

  return (
    <InstallProductService
      key={`${INSTALL_ID_PREFIX}${lineId}`}
      productSku={productSku}
      productLineId={lineId}
      productServiceLink={productServiceLink}
      suggestions={installSuggestions}
      preSelectedOfferingId={preSelectedOfferingId}
      variant={variant}
      facets={facets}
    />
  );
};

export const renderServicesModule = ({
  lineId,
  productSku,
  productServiceLink,
  nonInstallSuggestions,
  nonInstallServiceData,
  onAddService,
  gtmData,
  trackingMessage,
}: ServicesModuleConfig) => {
  if (!nonInstallSuggestions?.length || !nonInstallServiceData || !onAddService) return null;

  return (
    <ProductService
      key={`service-${lineId}`}
      productSku={productSku}
      productServiceLink={productServiceLink}
      serviceType={nonInstallServiceData.typeId}
      suggestions={nonInstallSuggestions}
      onAdd={onAddService}
      gtmData={gtmData}
      shouldHideHeading
      trackingMessage={trackingMessage}
    />
  );
};

export interface ServicesCarouselProps extends ServicesModuleConfig {
  slidesPerView?: number;
  isDesktop?: boolean;
}

export const ServicesCarousel = (props: ServicesCarouselProps) => {
  const { slidesPerView, isDesktop = false } = props;

  const installsModule = renderInstallModule(props);
  const servicesModule = renderServicesModule(props);

  const slides = [installsModule, servicesModule].filter(Boolean);
  if (slides.length === 0) return null;

  return isDesktop || slides.length === 1 ? (
    <div className={styles.servicesContainer}>{slides}</div>
  ) : (
    <Carousel showPagination={false} slidesPerView={slidesPerView} showProgressBar={false} showArrows={false} fullBleed>
      {slides}
    </Carousel>
  );
};
